import React from "react";
import { connect } from 'redux-bundler-react';
import ErrorBoundary from '../utils/error-boundary';
import { Resizable } from "re-resizable";

class PrimaryPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: props.primaryPanelWidth,
      left: 49,
      lastX: null
    };
    this.handleResize = this.handleResize.bind(this);
    this.updateStore = this.updateStore.bind(this);
  }

  handleResize(e){
    e.preventDefault();
    let { lastX, width } = this.state;
    const newX = e.clientX;
    if(newX && lastX){
      const delta = newX - lastX;
      this.setState({
        width: width + delta,
        lastX: newX
      });
    }else{
      this.setState({
        lastX: newX
      })
    }
  };
  
  updateStore(){
    const { doResizePrimaryPanel } = this.props;
    doResizePrimaryPanel(this.state);
  }

  render() {
    const { primaryPanelChildren, primaryPanelOptions } = this.props;
    const { left, width } = this.state;

    if(!primaryPanelChildren.length) return null;

    return (
      // <div className="sidebar-panel" style={{ left: left, width: width }}>
        
      //   <ErrorBoundary>
      //     <div id="primary-panel-content">
      //       {
      //         primaryPanelChildren.map((component, i) => {
      //           const Comp = component;
      //           return <Comp key={i} {...primaryPanelOptions}/>
      //         })
      //       }
      //     </div>
      //   </ErrorBoundary>
        
      //   <div
      //     className="e-w-drag-handle"
      //     draggable="true"
      //     onDrag={ this.handleResize }
      //     onDragEnd={ this.updateStore }
      //   />
      // </div>
      <div className="sidebar-panel" >
      <ErrorBoundary>
           <Resizable
           bounds='window'
           id='content'
              className="primary-panel-content"
              enable={{
                top:false, 
                right:true, 
                bottom:false, 
                left:false, 
                topRight:false, 
                bottomRight:false, 
                bottomLeft:false, 
                topLeft:false
              }}
              defaultSize={{
                width: 300,
                height: '98%'
              }}
              handleWrapperClass="e-w-drag-handle"
            >
              {
              primaryPanelChildren.map((component, i) => {
                const Comp = component;
                return <Comp key={i} {...primaryPanelOptions}/>
              })
            }
              </Resizable> 
          
        </ErrorBoundary>
        </div>
    );
  }
}

export default connect(
  'selectPrimaryPanelChildren',
  'selectPrimaryPanelOptions',
  'selectPrimaryPanelWidth',
  'doResizePrimaryPanel',
  PrimaryPanel
);
